import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { ROLE_LABELS, ROLE_COLORS } from './shared.js';

export default function InviteModal({ onClose, onInvite }) {
  const { theme, isDark } = useTheme();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [role, setRole] = useState('editor');
  const [inviting, setInviting] = useState(false);
  const [error, setError] = useState('');

  const handleInvite = async () => {
    if (!email.trim()) { setError('Email is required'); return; }
    setInviting(true);
    setError('');
    try {
      await onInvite({ email: email.trim(), name: name.trim() || undefined, role });
      onClose();
    } catch (err) {
      setError(err.data?.error || err.message || 'Failed to invite user');
    } finally {
      setInviting(false);
    }
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay, backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} style={{
        width: 420, padding: 28,
        background: isDark ? '#1A1A1E' : '#FFFFFF',
        borderRadius: 14, border: `1px solid ${theme.border}`,
        boxShadow: '0 16px 48px rgba(0,0,0,0.3)',
      }}>
        <h3 style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 700, color: theme.text }}>Invite Team Member</h3>

        {error && (
          <div style={{ padding: '8px 12px', marginBottom: 16, background: theme.redBg, border: `1px solid ${theme.redBorder}`, borderRadius: 8, color: theme.red, fontSize: 12 }}>{error}</div>
        )}

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>Email *</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="colleague@riester.com" autoFocus
            style={{ width: '100%', padding: '10px 12px', background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>Name</label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Full name (optional)"
            style={{ width: '100%', padding: '10px 12px', background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>Role</label>
          <div style={{ display: 'flex', gap: 8 }}>
            {['viewer', 'editor', 'admin'].map(r => (
              <button key={r} onClick={() => setRole(r)} style={{
                flex: 1, padding: '10px 8px', fontSize: 12, fontWeight: 600,
                background: role === r ? `${ROLE_COLORS[r]}18` : theme.bgInput,
                border: `1px solid ${role === r ? `${ROLE_COLORS[r]}40` : theme.borderMedium}`,
                borderRadius: 8, color: role === r ? ROLE_COLORS[r] : theme.textMuted,
                cursor: 'pointer', fontFamily: 'inherit', textTransform: 'capitalize',
              }}>
                <div>{ROLE_LABELS[r]}</div>
                <div style={{ fontSize: 10, fontWeight: 400, marginTop: 2, opacity: 0.7 }}>
                  {r === 'viewer' && 'Browse only'}
                  {r === 'editor' && 'Upload & edit'}
                  {r === 'admin' && 'Full access'}
                </div>
              </button>
            ))}
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', fontSize: 12, fontWeight: 500, background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.textMuted, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          <button onClick={handleInvite} disabled={inviting} style={{
            padding: '10px 24px', fontSize: 12, fontWeight: 600,
            background: inviting ? theme.bgInput : 'linear-gradient(135deg, #4F8EF7, #7C5CFC)',
            border: 'none', borderRadius: 8, color: inviting ? theme.textMuted : '#fff',
            cursor: inviting ? 'not-allowed' : 'pointer', fontFamily: 'inherit',
          }}>{inviting ? 'Inviting...' : 'Send Invite'}</button>
        </div>
      </div>
    </div>
  );
}
